import { Component, computed, inject, output } from "@angular/core"
import { FirestoreReadService } from "../content/firestore-read.service"
import { ProfileService } from "../user-profile/profile.service"
import { UiIconComponent } from "ui-icon"
import { faTag } from "@fortawesome/free-solid-svg-icons"

@Component({
  imports: [
    UiIconComponent,
  ],
  standalone: true,
  template: `
    <button
      class="btn bg-primary text-primary-content rounded-full uppercase w-full"
      (click)="createNewContent.emit()"
    >
      <lib-ui-icon [icon]="faTag"/>
      @if (!loggedIn()) {
        SIGN IN / SIGN-UP TO SHARE
      }
      @if (loggedIn()) {
        Propose a Story, Reflection or History
      }
    </button>
  `,
  selector: "e2e-share-your-story",
})
export class ShareYourStoryComponent {
  private firestoreReadService = inject(FirestoreReadService)
  private profileService = inject(ProfileService)

  createNewContent = output<void>()

  loggedIn = this.profileService.loggedIn

  myContentCount = computed(
    () =>
      this.firestoreReadService
        .arrayFromStories()
        .filter((story) => story.created.userId === this.profileService.userId()).length,
  )
  protected readonly faTag = faTag
}
